export const SECTION_ORDER_BY_EDITOR_MODE = {
	designStudio: [
		'formats',
		'listing',
		'brand',
		'text',
		'photos',
		'videos',
		'elements',
		'upload',
		'draw',
		'qrcode',
		'background',
	],
	designManager: [
		'formats',
		'brand',
		'text',
		'photos',
		'videos',
		'elements',
		'upload',
		'draw',
		'qrcode',
		'background',
		'layers',
	],
};

export const SECTION_SORT_KEY_ALIASES = {
	video: 'videos',
	listingimages: 'listing',
};
